export default __webpack_public_path__ + "static/media/SPINS Sharepoint logo.fdeb504e.png";